export const initialValues = {
  title: '',
  icon: '',
  description: '',
  breadcrumbs: [],
  extraResources: {
    label: '',
    items: []
  }
};

export const linkDefaults = {
  text: '',
  url: '',
};
